import routeConfig from "@config/routes";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { DebugPage } from "@pages/DebugPage";
import { GDPRPage } from "@pages/GDPRPage";
import { ImprintPage } from "@pages/ImprintPage";
import { LandingPage } from "@pages/LandingPage";
import { NotFoundPage } from "@pages/NotFoundPage";
import { useSidebarPaddings } from "containers/hooks/useWindowSize";
import ConfigSidebar from "containers/Sidebar/ConfigSidebar";
import { Navigate, Route, Routes } from "react-router-dom";
import NavSidebar from "../NavbarComponents/NavSidebar";
import { AppRouter } from "./AppRouter";
import { Header } from "./Header";
import { BottomBar } from "./BottomBar";

function App() {
  const { left, right } = useSidebarPaddings();
  const theme = useTheme();

  return (
    <Routes>
      <Route
        path={routeConfig.Root}
        element={
          <>
            <Header />
            <LandingPage />
          </>
        }
      />
      <Route
        path={routeConfig.Debug}
        element={
          <>
            <Header />
            <Box sx={{ height: theme.sidebar.headerHeight }} />
            <DebugPage />
          </>
        }
      />
      <Route
        path={routeConfig.Imprint}
        element={
          <>
            <Header />
            <Box sx={{ height: theme.sidebar.headerHeight }} />
            <ImprintPage />
          </>
        }
      />
      <Route
        path={routeConfig.Dsgvo}
        element={
          <>
            <Header />
            <Box sx={{ height: theme.sidebar.headerHeight }} />
            <GDPRPage />
          </>
        }
      />
      <Route
        path="/app/*"
        element={
          <>
            <NavSidebar />
            <ConfigSidebar />
            <BottomBar />
            <Box
              sx={{
                paddingLeft: `${left}px`,
                paddingRight: `${right}px`,
                height: "100%",
              }}
            >
              <AppRouter />
            </Box>
          </>
        }
      />
      {/* Support to reroute old links to new page */}
      <Route path="/visualization/*" element={<Navigate to={"/app/"} />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
